import { render } from "./MyBill.vue?vue&type=template&id=21040aad&scoped=true"
import script from "./MyBill.vue?vue&type=script&lang=js"
export * from "./MyBill.vue?vue&type=script&lang=js"

import "./MyBill.vue?vue&type=style&index=0&id=21040aad&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21040aad"]])

export default __exports__